var map = {
	"./105/photoAlbum1.jpg": "30b4",
	"./138/photoAlbum1.jpg": "adb1",
	"./163/photoAlbum1.jpg": "1be1",
	"./210/photoAlbum1.jpg": "2a90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "135d";